'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ReportsIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ReportsIcon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={sx?.color ? sx.color : '#273443'}
      >
        <g clipPath="url(#clip0_3182_11987)">
          <path d="M0.504028 23.25H23.504" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M4.5 23.25V20.75C4.5 20.6174 4.44732 20.4902 4.35355 20.3964C4.25979 20.3027 4.13261 20.25 4 20.25H2C1.86739 20.25 1.74021 20.3027 1.64645 20.3964C1.55268 20.4902 1.5 20.6174 1.5 20.75V23.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 23.25V16.75C10.5 16.6174 10.4473 16.4902 10.3536 16.3964C10.2598 16.3027 10.1326 16.25 10 16.25H8C7.86739 16.25 7.74021 16.3027 7.64645 16.3964C7.55268 16.4902 7.5 16.6174 7.5 16.75V23.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.5 23.25V12.75C16.5 12.6174 16.4473 12.4902 16.3536 12.3964C16.2598 12.3027 16.1326 12.25 16 12.25H14C13.8674 12.25 13.7402 12.3027 13.6464 12.3964C13.5527 12.4902 13.5 12.6174 13.5 12.75V23.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5 23.25V8.75C22.5 8.61739 22.4473 8.49021 22.3536 8.39645C22.2598 8.30268 22.1326 8.25 22 8.25H20C19.8674 8.25 19.7402 8.30268 19.6464 8.39645C19.5527 8.49021 19.5 8.61739 19.5 8.75V23.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M3.00403 13.25L21.004 1.25" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20.504 5.25L21.004 1.25L17.004 0.75" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_3182_11987">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

ReportsIcon.propTypes = {
  sx: PropTypes.object
}
